import { CustomAxios } from '@/services';

export const AuthService = {
  login({ email, password }) {
    return CustomAxios.post('login', {
      user: { email, password },
    });
  },
};
